export default __webpack_public_path__ + "static/media/ASSET_04@2x.f07eda56.png";